import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select-legacy';
import { isEmpty } from 'lodash';
import { isAdminDashboard } from '../../utils/authScopes';
import { useTranslation } from 'react-i18next';

const BulkMessageRecipients = ({
  auth, filters, meta,
  onAccountChange, onCohortChange, onGroupChange, onPartnerChange, onAgeRangeChange,
  withScope
}) => {
  const { t } = useTranslation();
  const noScope = !withScope.group && !withScope.cohort;
  const groupsScope = withScope.group;
  const allowGroups = noScope || groupsScope;

  return (
    <div className='row u-margin-top--base'>
      <div className='column small-12'>
        <label>{t('bulkSending.chooseAccounts')}</label>
      </div>
      { isAdminDashboard(auth) &&
        <div className='column small-12 medium-4 large-3 u-margin-bottom--base'>
          <Select
            name='sp-partner-select'
            className={'o-select o-select--optgroup'}
            value={meta.partner || ''}
            onChange={onPartnerChange}
            options={filters.partners || []}
            placeholder={t('bulkSending.selectPartner')}/>
        </div>
      }
      <div className='column small-12 medium-4 large-3 u-margin-bottom--base'>
        <Select
          name='sp-group-select'
          className={'o-select o-select--optgroup'}
          disabled={!allowGroups || !isEmpty(meta.accountIds) || !isEmpty(meta.cohortIds)}
          multi={true}
          value={meta.groupIds || []}
          onChange={onGroupChange}
          options={filters.groups || []}
          placeholder={t('bulkSending.selectGroups')} />
      </div>
      <div className='column small-12 medium-4 large-3 u-margin-bottom--base'>
        <Select
          name='sp-cohort-select'
          className={'o-select o-select--optgroup'}
          disabled={!isEmpty(meta.accountIds) || !isEmpty(meta.groupIds)}
          multi={true}
          value={meta.cohortIds || []}
          onChange={onCohortChange}
          options={filters.cohorts || []}
          placeholder={t('bulkSending.selectCohorts')} />
      </div>
      <div className='column small-12 medium-4 large-3 u-margin-bottom--base'>
        <Select
          name='sp-account-select'
          className={'o-select o-select--optgroup'}
          disabled={(!isEmpty(meta.cohortIds)) || !isEmpty(meta.groupIds)}
          multi={true}
          value={meta.accountIds || []}
          onChange={onAccountChange}
          options={filters.accounts || []}
          placeholder={t('bulkSending.selectAccounts')} />
      </div>
      <div className='column small-12 medium-4 large-3 u-margin-bottom--base'>
        <Select
          name='sp-account-select'
          className={'o-select o-select--optgroup'}
          multi={true}
          value={meta.ageRanges || []}
          onChange={onAgeRangeChange}
          options={filters.ages || []}
          placeholder={t('bulkSending.selectAgeRanges')} />
      </div>
    </div>
  );
};

BulkMessageRecipients.propTypes = {
  auth: PropTypes.object.isRequired,
  filters: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  withScope: PropTypes.object.isRequired,
  onAccountChange: PropTypes.func.isRequired,
  onCohortChange: PropTypes.func.isRequired,
  onGroupChange: PropTypes.func.isRequired,
  onAgeRangeChange: PropTypes.func.isRequired,
  onPartnerChange: PropTypes.func.isRequired,
}

export default BulkMessageRecipients;
